export default __webpack_public_path__ + "static/media/triangle.5c6eb0ee.png";